import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/auto_ventas/ventas/ventas';
import VendedoresList from './VentasList';


const ms2p = (state) => {
  return {
    ...state.auto_ventas_ventas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(VendedoresList);
